import DigitalPracticeRAv2 from './component';

import _routes from './routes';

export const routes = _routes;

export default DigitalPracticeRAv2;



// WEBPACK FOOTER //
// ./containers/Group/DigitalPracticeRAv2/index.js